import { HighlightedText, Text } from 'common-components'

import FramesSelector from './FramesSelector'
import { useRecommendedSizeLabel } from './hooks/useRecommendedSizeLabel'

import * as Styled from './styled'

import { useDispatch, useSelector } from 'react-redux'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { memo, useEffect } from 'react'
import { DisabledWrapper } from '../DisabledWrapper'
import SingleRefContainer from './SingleRefContainer'
import TabbedRefContainer from './TabbedRefContainer'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { ReferenceMode } from '../../consts'
import { getImageReferencesTitle, getSupportedFormatsLabel } from './utils'
import { LINE_HEIGHT_OFFSET } from 'consts'

const UploadMediaSection = () => {
  const dispatch = useDispatch()

  const isFirstAndLastFrameSupported = useSelector(
    aiVideoSelectors.isFirstAndLastFrameSupported
  )
  const isMultiRefSupported = useSelector(aiVideoSelectors.isMultiRefSupported)
  const referenceMode = useSelector(aiVideoSelectors.referenceMode)
  const multiRefMaxImageCount = useSelector(
    aiVideoSelectors.multiRefMaxImageCount
  )
  const lastFrameUrl = useSelector(aiVideoSelectors.lastFrameUrl)
  const supportedImageMimeTypes = useSelector(
    aiVideoSelectors.supportedImageMimeTypes
  )

  const recommendedSizeLabel = useRecommendedSizeLabel()
  const supportedTypes = getSupportedFormatsLabel(supportedImageMimeTypes)
  const title = [
    {
      condition: !isFirstAndLastFrameSupported,
      title: translate(T.SOURCE_LABEL)
    },
    {
      condition: !isMultiRefSupported || referenceMode === ReferenceMode.FRAMES,
      title: translate(T.REFERENCES_LABEL)
    },
    {
      condition: isMultiRefSupported,
      title: getImageReferencesTitle(multiRefMaxImageCount)
    }
  ].find(item => item.condition)?.title

  useEffect(() => {
    if (!isFirstAndLastFrameSupported && lastFrameUrl) {
      dispatch(aiVideoThunks.removeLastFrame())
    }
  }, [isFirstAndLastFrameSupported, lastFrameUrl, dispatch])

  return (
    <DisabledWrapper>
      <Styled.UploadMediaSectionContainer>
        {title && (
          <Text type="subtitle" lineHeight="18px" color="secondaryDark">
            <HighlightedText
              text={title}
              elementType="span"
              attributes={{
                className: 'tinted'
              }}
            />
          </Text>
        )}
        {!isFirstAndLastFrameSupported ? (
          <SingleRefContainer />
        ) : isMultiRefSupported ? (
          <TabbedRefContainer />
        ) : (
          <FramesSelector />
        )}
        <Styled.ModelInfo>
          {recommendedSizeLabel && (
            <Text type="h4" lineHeight={LINE_HEIGHT_OFFSET} color="secondary">
              {recommendedSizeLabel}
            </Text>
          )}
          {supportedTypes && (
            <Text type="h4" lineHeight={LINE_HEIGHT_OFFSET} color="secondary">
              {translate(T.SUPPORTED_FORMATS_LABEL)}: {supportedTypes}
            </Text>
          )}
        </Styled.ModelInfo>
      </Styled.UploadMediaSectionContainer>
    </DisabledWrapper>
  )
}

export default memo(UploadMediaSection)
